import { useQuery } from "@tanstack/react-query";
import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
} from "recharts";
import { api } from "../../lib/api";
import { PageLoader } from "../ui";

export function ProductImpressionTrendPopover({
  productId,
  productName,
}: {
  productId: string;
  productName: string;
}) {
  const trendQuery = useQuery({
    queryKey: ["product-impression-trend", productId],
    queryFn: () =>
      api<{ points: { date: string; listing: number; detail: number }[] }>(
        `/catalog/products/${productId}/impression-trend?days=30`,
      ),
  });

  if (trendQuery.isLoading) return <PageLoader />;

  const points = trendQuery.data?.points ?? [];

  return (
    <div className="w-[min(22rem,calc(100vw-2rem))] space-y-2 p-1">
      <p className="text-xs font-semibold text-foreground">{productName}</p>
      <p className="text-[10px] text-muted">30-day views · listing vs product page</p>
      {points.length === 0 ? (
        <p className="py-6 text-center text-xs text-muted">No impression data yet.</p>
      ) : (
        <div className="h-44 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={points} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
              <XAxis dataKey="date" tick={{ fontSize: 9 }} tickFormatter={(v) => String(v).slice(5)} />
              <YAxis tick={{ fontSize: 9 }} allowDecimals={false} width={28} />
              <Tooltip
                contentStyle={{ fontSize: 11, borderRadius: 8 }}
                labelFormatter={(label) => String(label)}
              />
              <Legend wrapperStyle={{ fontSize: 10 }} />
              <Line type="monotone" dataKey="listing" name="Listing" stroke="#ec4899" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="detail" name="Detail" stroke="#60a5fa" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
